import { h } from "preact";

import { useMemo } from "preact/hooks";

import NoteStatus from "../../../../foundation/model/NoteStatus";
import RemarkType from "../../../../foundation/model/RemarkType";
import classname from "../../../../foundation/utils/classname";

import IconAddComment from "../../Icons/IconAddComment";

import IconUnreadComment from "../../Icons/IconUnreadComment";

import { Props } from "./ScreenCardCommentsBadgeProps";

import styles from "./ScreenCardCommentsBadge.module.css";

function ScreenCardCommentsBadge({
    class: cssClass,
    screenDots: screenDotsRaw,
    onClick
}: Props) {
    const screenDots = screenDotsRaw?.filter(dot => dot.dotType !== RemarkType.ApprovalNote);

    const unresolvedCommentCount = useMemo(
        () => screenDots?.filter(screenDot => screenDot.status === NoteStatus.OPEN).length || 0,
        [screenDots]
    );

    const unreadCommentCount = useMemo(
        () => screenDots?.filter(screenDot =>
            screenDot.status !== NoteStatus.RESOLVED && screenDot.comments.some(comment => comment.isUnread)
        ).length || 0,
        [screenDots]
    );

    function handleClick() {
        onClick();

        mixpanel.master.track("Click Comment Indicator on Screen Preview");
    }

    if (unresolvedCommentCount === 0 && unreadCommentCount === 0) {
        return null;
    }

    return (
        <div
            class={classname(styles.screenCardCommentsBadge, cssClass, {
                [styles.hasUnreadComment]: unreadCommentCount > 0
            })}
            onClick={handleClick}>
            {unreadCommentCount > 0 ? <IconUnreadComment/> : <IconAddComment/>}
            <span class={classname("caption-2 semibold", styles.count)}>{unreadCommentCount || unresolvedCommentCount}</span>
        </div>
    );
}

export default ScreenCardCommentsBadge;
